import {DictionaryEntries} from "@web-libs/core/internationalization/dictionary.types";

export const validateUsername = (username: string|undefined, dict: DictionaryEntries) => {
    if(!username) return true;
    // Only allow ASCII letters, numbers, underscores, and hyphens
    // This prevents international characters like "å", "ü", "ö", etc.
    const regex = /^[a-zA-Z0-9_-]+$/;
    return regex.test(username) || dict.validator.invalidUsernameCharacters;
}
